import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import styles from "./ConfirmationPopin.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import AppRow from "src/commun/composants/grille/AppRow";

export type ConfirmationPopinProps = {
  text: string;
  validerLabel: string;
  annulerLabel?: string;
  validerHandler: () => void;
  annulerHandler?: () => void;
};

const ConfirmationPopin = ({
  text,
  validerLabel,
  annulerLabel,
  validerHandler,
  annulerHandler,
}: ConfirmationPopinProps) => {
  const { tString } = useAppText();
  return (
    <div className={styles.container}>
      <p>{tString(text)}</p>
      <div className={styles.buttonBar}>
        <AppRow>
          <AppCol md={{offset:2, span:2}}>
            <input
              className={`btn__primary mt-3 btn--full--xs ${styles.btnMinWidth}`}
              type="submit"
              name="valider"
              onClick={validerHandler}
              value={tString(validerLabel)}
            />
          </AppCol>
          {annulerLabel && (
            <AppCol md={{offset:3, span:2}}>
              <input
                className={`btn__secondary mt-3 btn--full--xs ${styles.btnMinWidth}`}
                type="submit"
                name="annuler"
                onClick={annulerHandler}
                value={tString(annulerLabel)}
              />
            </AppCol>
          )}
        </AppRow>

      </div>
    </div>
  );
};

export default ConfirmationPopin;
